import {
  EFormDisplayRule,
  EFormFieldDataType,
  EFormFieldMapping,
  TPreChatFormFieldFormValue,
} from '~/features/preChatForms/models'

export const PRE_CHAT_FORM_DISPLAY_RULE_LABELS: Record<
  EFormDisplayRule,
  string
> = {
  [EFormDisplayRule.everyConversation]: 'Show for every conversation',
  [EFormDisplayRule.everyConversationPrefilled]: 'Show for every conversation',
  [EFormDisplayRule.oncePerGuestId]: 'Show once per browser',
}

export const PRE_CHAT_FORM_FIELD_LABELS: Record<EFormFieldMapping, string> = {
  [EFormFieldMapping.contactFirstName]: 'First name',
  [EFormFieldMapping.contactLastName]: 'Last name',
  [EFormFieldMapping.contactEmail]: 'Email',
  [EFormFieldMapping.contactPhone]: 'Phone',
}

export const PRE_CHAT_FORM_FIELD_DATA_TYPE_LABELS: Record<
  EFormFieldDataType,
  string
> = {
  [EFormFieldDataType.string]: 'Text',
  [EFormFieldDataType.email]: 'Email',
  [EFormFieldDataType.phone]: 'Phone',
}

export const DEFAULT_PRE_CHAT_FORM_FIELD_MAPPINGS: EFormFieldMapping[] = [
  EFormFieldMapping.contactFirstName,
  EFormFieldMapping.contactLastName,
  EFormFieldMapping.contactEmail,
  EFormFieldMapping.contactPhone,
]

export const DEFAULT_PRE_CHAT_FORM_FIELDS: TPreChatFormFieldFormValue[] = [
  {
    fieldMapping: EFormFieldMapping.contactFirstName,
    displayName: PRE_CHAT_FORM_FIELD_LABELS[EFormFieldMapping.contactFirstName],
    dataType: EFormFieldDataType.string,
    inForm: true,
    required: true,
  },
  {
    fieldMapping: EFormFieldMapping.contactLastName,
    displayName: PRE_CHAT_FORM_FIELD_LABELS[EFormFieldMapping.contactLastName],
    dataType: EFormFieldDataType.string,
    inForm: true,
    required: false,
  },
  {
    fieldMapping: EFormFieldMapping.contactEmail,
    displayName: PRE_CHAT_FORM_FIELD_LABELS[EFormFieldMapping.contactEmail],
    dataType: EFormFieldDataType.email,
    inForm: true,
    required: true,
  },
  {
    fieldMapping: EFormFieldMapping.contactPhone,
    displayName: PRE_CHAT_FORM_FIELD_LABELS[EFormFieldMapping.contactPhone],
    dataType: EFormFieldDataType.phone,
    inForm: false,
    required: false,
  },
]
